import type { SiteThemeFonts } from '@/types/database';

export interface FontPack {
  id: string;
  name: string;
  fonts: Pick<SiteThemeFonts, 'headingFont' | 'paragraphFont' | 'buttonFont' | 'miscFont'>;
}

// One-click bulk-set for the four font roles below — a real font pairing,
// not just "pick any two fonts". Each role stays individually overridable
// afterward on the Fonts screen; applying a pack is a starting point, not
// a locked bundle.
export const FONT_PACKS: FontPack[] = [
  {
    id: 'classic-elegance',
    name: 'Classic Elegance',
    fonts: { headingFont: 'marcellus', paragraphFont: 'open-sans', buttonFont: 'open-sans', miscFont: 'open-sans' },
  },
  {
    id: 'bold-adventure',
    name: 'Bold Adventure',
    fonts: { headingFont: 'poppins', paragraphFont: 'inter', buttonFont: 'poppins', miscFont: 'inter' },
  },
  {
    id: 'traditional',
    name: 'Traditional',
    fonts: { headingFont: 'playfair-display', paragraphFont: 'lato', buttonFont: 'lato', miscFont: 'lato' },
  },
  {
    id: 'modern-grotesque',
    name: 'Modern Grotesque',
    fonts: { headingFont: 'inter', paragraphFont: 'inter', buttonFont: 'inter', miscFont: 'inter' },
  },
  {
    id: 'timeless',
    name: 'Timeless',
    fonts: { headingFont: 'georgia', paragraphFont: 'system', buttonFont: 'system', miscFont: 'system' },
  },
  {
    id: 'friendly',
    name: 'Friendly',
    fonts: { headingFont: 'poppins', paragraphFont: 'open-sans', buttonFont: 'open-sans', miscFont: 'open-sans' },
  },
];
